import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

export default function RegistrationGateModal() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener('bmc:open-registration-gate', handler);
    return () => window.removeEventListener('bmc:open-registration-gate', handler);
  }, []);

  const handleContinue = () => {
    setOpen(false);
    navigate('/login');
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Create a free account to continue</DialogTitle>
          <DialogDescription>
            Sign up to contact this teacher, save your search, and get personalised recommendations.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-3 pt-2">
          <Button onClick={handleContinue} className="w-full cursor-pointer">
            Sign up — it's free
          </Button>
          <Button variant="ghost" onClick={handleContinue} className="w-full cursor-pointer text-sm">
            Already have an account? Log in
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
